import React from 'react';

import { AddButton } from '../../../../components/Button';
import CommonDataGrid from '../../../../components/CommonDataGrid';
import { Column } from '../../../../components/CommonDataGrid/props';
import Loader from '../../../../components/Loader';
import EditImg from '../../../../images/SideBar/Edit';
import ViewImg from '../../../../images/SideBar/View';
import useDocument from '../useDocument';
import EditDocumentIndex from './EditDocument/index';

const Document: React.FC = () => {
  const {
    selectedDocumentId,
    documentData,
    updateScreen,
    handleEdit,
    handleAdd,
    handleDateFilter,
    setSearch,
    setPage,
    page,
    loading,
    totalPage,
  } = useDocument();

  const columns: Column[] = [
    {
      field: "title",
      headerName: "Document title",
      width: 50,
      align: "center",
    },
    {
      field: "tag",
      headerName: "Document tag",
      width: 50,
      align: "center",
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 50,
      align: "center",
      renderCell: (params: any) => (
        <div className="flex space-x-2 justify-center">
          <button
            onClick={() => handleEdit(params.row._id)}
            className="text-fontColor hover:text-primary-2"
          >
            <ViewImg />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="m-5 h-[80vh] overflow-x-auto">
        {loading && <Loader />}
        <div>
          {selectedDocumentId ? (
            <EditDocumentIndex
              documentId={selectedDocumentId}
              setMethod={() => updateScreen("edit")}
            />
          ) : (
            <>
              <div className="grid justify-items-end -mb-16 mr-5">
                <AddButton
                  onClick={handleAdd}
                  className="  "
                  children="+"
                  type="button"
                />
              </div>
              <CommonDataGrid
                tableName="Document"
                rows={documentData}
                columns={columns}
                getRowId={(row) => row._id}
                showConfirmation={false}
                confirmationMessage= "Are you sure you want to Status Update this Document?"
                onCancelDelete={() => {}}
                onConfirmDelete={() => {}}
                loading={!documentData}
                onDateFilter={handleDateFilter}
                addButton
                setSearchBar={setSearch}
                setCurrentPage={setPage}
                currentPage={page}
                totalPages={totalPage}
                dayFilter={false}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Document;
